import React from "react"
import CircularProgress from '@material-ui/core/CircularProgress';
import SheetHelper from "./../../helpers/sheet"
import styled from 'styled-components';

//import Button from '@material-ui/core/Button';

const Button = styled.button`
  padding: 0.25em 1em;
  margin: 0;
  margin-top:30px;
  background: #20323f;
  color: #fff;
  border: 0
  width:100%;
  font-size: 12px;
  padding: 15px;
  border-radius:5px !important;
`;

export default class SheetExport extends React.Component{
    constructor(props){
      super(props)
      this.state = {
        loading: false,
        exported: false,
        spreadsheet: undefined,
      }
    }

    buttonClicked(){
      if (!this.state.exported){
        this.export()
      } else {
        if (this.state.spreadsheet){
          var win = window.open(this.state.spreadsheet.spreadsheetUrl, '_blank');
          win.focus();
          this.setState({exported: false})
        }
      }
    }

    async copyTemplateFile() {
      const templateFileId = process.env.REACT_APP_GOOGLE_SHEET_TEMPLATE_ID
      const resp = await SheetHelper.copyFile(templateFileId, "Telescope Data Export")

      return resp
    }

    async export() {
      this.setState({
        loading: true
      })
      let spreadsheet = await this.copyTemplateFile()

      let data = await this.props.getData()
      let y = 2

      await addSections(data)
      this.setState({spreadsheet: spreadsheet, exported: true, loading: false})

      async function addSections(data, i = 0){

          if (data.sections && data.sections.length <= 0) return

          let section = data.sections[i]
          spreadsheet = await SheetHelper.createSection(spreadsheet, {...section, ...{
              y: y
          }})

          y += section.rows.length + 2
          if(data.sections.length - 1 > i){
              await addSections(data, i + 1)
          } else return
      }

    }
    render(){
      const {getData, ...rest} = this.props
        return (
          <div {...rest}>
            <div style={{display: "flex", flexDirection: "column"}}>
              <div style={{height: 1, backgroundColor: "black", marginTop: 32, marginBottom: 32}}></div>
              {!this.props.data || !this.props.data.variableData ? (
                <p>Fetching data...</p>
              ):(
                <div>
                  <p>Export to google sheet:</p>
                  <div style={{position: "relative",}}>
                    <Button disabled={this.state.loading} onClick={() => this.buttonClicked()} variant="contained" color="primary">
                      {this.state.loading && !this.state.exported ? "Exporting..." : this.state.exported ? "Open sheet" : "Export"}
                    </Button>
                    {this.state.loading ? <CircularProgress size={24} style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: -12,
                      marginLeft: -12,
                    }} /> : null}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/export-google-sheet/components/sheetExport/index.js